import "./App.css";
import "./custom.css";
import Hero from "./Pages/Hero";
import Navbar from "./Components/Navbar";
import ProjectShowCase from "./Pages/.Projects/ProjectShowCase";
import Aboutus from "./Pages/.Projects/Aboutus";
import Contact from "./Pages/.Projects/Contact";
import Project1_Details from "./Pages/Projects/Project1";
import Project2Details from "./Pages/Projects/Project2Details";
import Project3Details from "./Pages/Projects/Project3Details";
import Project4Details from "./Pages/Projects/Project4Details";
import Project5Details from "./Pages/Projects/Project5Details";
import Project6Details from "./Pages/Projects/Project6Details";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Layout from "./LayOut";


function App() {
  // useEffect(() => {
  //   // Function to handle context menu
  //   const handleContextMenu = (event) => {
  //     event.preventDefault();
  //   };

  //   // Function to handle keydown events
  //   const handleKeyDown = (event) => {
  //     // Ctrl + Shift + C
  //     if (event.ctrlKey && event.shiftKey && event.key === 'C') {
  //       event.preventDefault();
  //     }

  //     // You can add more key combinations here
  //     // e.g., disable F12 (Developer Tools)
  //     if (event.key === 'F12') {
  //       event.preventDefault();
  //     }

  //     // Disable Ctrl + U (View Source)
  //     if (event.ctrlKey && event.key === 'U') {
  //       event.preventDefault();
  //     }

  //     // Disable Ctrl + Shift + I (Developer Tools)
  //     if (event.ctrlKey && event.shiftKey && event.key === 'I') {
  //       event.preventDefault();
  //     }
  //   };

  //   // Add event listeners
  //   document.addEventListener('contextmenu', handleContextMenu);
  //   document.addEventListener('keydown', handleKeyDown);

  //   // Cleanup on component unmount
  //   return () => {
  //     document.removeEventListener('contextmenu', handleContextMenu);
  //     document.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, []);
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/about" element={<Aboutus />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<ProjectShowCase />} />
          <Route path="/project0-details" element={<Project6Details />} />
          <Route path="/project1-details" element={<Project1_Details />} />
          <Route path="/project2-details" element={<Project2Details />} />
          <Route path="/project3-details" element={<Project3Details />} />
          <Route path="/project4-details" element={<Project4Details />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
